<template>
    <div class="spell">
        <VTooltip>
            <Image :src="$cdn.url('lol', ['spells', gid || blankId], 'png')" :size="Isize"/>

            <template #popper>
                <div class="description" v-if="gid">
                    <span class="fw-bold" :style="{fontSize: '14px', color: colors.title}">{{$asset.lol.spells[gid].name}}</span>
                    <hr class="my-2">
                    <span v-html="$asset.lol.spells[gid].description"></span>
                    <span class="text-info fw-bold mt-2 d-block" v-if="$asset.lol.spells[gid].cooldown"
                    >Cooldown: {{$asset.lol.spells[gid].cooldown}}s</span>
                </div>
            </template>
        </VTooltip>
    </div>
</template>

<style lang="scss" scoped>
.spell {
    // border-radius: 50%;
    overflow: hidden;
    position: relative;
}

.mythic-outline {
    outline: 1px solid rgb(242, 255, 0);
    outline-offset: -1px;
    border-radius: 50%;
}

.description {
    white-space: pre-wrap;
    max-width: min(100vw, 500px);
    font-size: 13px;
}
</style>

<script lang="ts">
import { Watch, Prop } from 'vue-property-decorator'
import { Options, Vue } from 'vue-class-component'
import Image from '../Image.vue'

@Options({components: {Image}})
export default class Spell extends Vue {

    Isize: number | string = ""
    uuid!: string
    blankId = 54

    @Prop() readonly gid!: number
    @Prop({default: "100%"}) readonly size!: number
    @Prop({default: []}) readonly rSize!: Array<number>

    colors: Record<string, string> = {
        "title": "rgb(0, 223, 126)",
        "attribute": "rgb(0, 223, 201)"
    }

    get winWidth(): number {
        return this.$store.state.winWidth
    }

    created (): void {
        this.uuid = this.$uuid.uuid1()
        this.getSize(this.winWidth)
    }

    @Watch('winWidth')
    getSize(after: number | string): void {
        if (this.rSize.length == 0)
            this.Isize = this.$css.asDimension(this.size)
        else if (after < 576)
            this.Isize = this.$css.asDimension(this.rSize[0])
        else if (after < 992)
            this.Isize = this.$css.asDimension(this.rSize[1])
        else
            this.Isize = this.$css.asDimension(this.rSize[2])
    }

}
</script>
